<script setup>
import SvgIcon from "./SvgIcon.vue";
</script>

<template>
  <p class="page-loading">
    <SvgIcon class="spinner" name="system/loader" width="20" height="20" />
    <slot />
  </p>
</template>

<style lang="scss" scoped>
.page-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 16px auto;
}

.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
